module.exports = __webpack_public_path__ + "07871437a5e21be2622657f8dd140b39.fbx";